module.exports = __webpack_public_path__ + "static/power4-3@2x-e997a997a5372a9fbdc525b6c0b00add.png";